import { render, staticRenderFns } from "./BackToServices.vue?vue&type=template&id=60ea94a6&scoped=true&"
import script from "./BackToServices.vue?vue&type=script&lang=js&"
export * from "./BackToServices.vue?vue&type=script&lang=js&"
import style0 from "./BackToServices.vue?vue&type=style&index=0&id=60ea94a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ea94a6",
  null
  
)

export default component.exports